/**
 * Configuration required for Amplify.
 * Ref: https://docs.amplify.aws/lib/client-configuration/configuring-amplify-categories/q/platform/js/
 */

export const envConfig = {
  Auth: {
    // (required) only for Federated Authentication - Amazon Cognito Identity Pool ID
    identityPoolId: 'us-west-2:e7e9f2b2-9af5-41e7-9b1d-3bf54e317196',

    // (required)- Amazon Cognito Region
    region: 'us-west-2',

    // (optional) - Amazon Cognito User Pool ID
    userPoolId: 'us-west-2_60KGDACXj',

    // (optional) - Amazon Cognito Web Client ID (26-char alphanumeric string, App client secret needs to be disabled)
    userPoolWebClientId: '44lqqcqd4hl6uinsc4e5fb7bke',

    // (optional) - Enforce user authentication prior to accessing AWS resources or not
    mandatorySignIn: true,

    // (optional) - Hosted UI configuration
    oauth: {
      domain: 'finance-allocation-access-control-gamma' + '.auth.us-west-2.amazoncognito.com',
      redirectSignIn: 'https://' + window.location.host + '/',
      redirectSignOut: 'https://' + window.location.host + '/',
      scope: ['openid'],
      responseType: 'code',
    },
  },
  API: {
    endpoints: [
      {
        name: 'FinanceAllocationsService',
        endpoint: 'https://gamma-api.allocations.finergy.amazon.dev',
      },
      {
        name: 'TaskSchedulingService',
        endpoint: 'https://gamma-api.taskscheduling.finergy.amazon.dev',
      },
      {
        name: 'FAEAuthService',
        endpoint: 'https://gamma-authz.allocations.finergy.amazon.dev',
      },
    ],
  },
  Storage: {
    AWSS3: {
      bucket: 'allocations-driver-mapping-gamma',
      region: 'us-west-2',
    },
  },
};
